import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Autocomplete, Box, FormControl, TextField, Chip } from "@mui/material";
import styles from "./multiFieldSelect.module.scss";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Field } from "formik";
import { ReactComponent as CheckBoxTickIcon } from "../../../assets/icons/TypeChecked.svg";
import { ReactComponent as CheckBoxUncheckIcon } from "../../../assets/icons/TypeDefault.svg";
import { ReactComponent as CheckBoxPartialIcon } from "../../../assets/icons/TypePartial.svg";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import i18next from "i18next";
import _ from "lodash";
import PropTypes from "prop-types";

const icon = <CheckBoxUncheckIcon fontSize="small" />;
const checkedIcon = <CheckBoxTickIcon fontSize="small" />;

function ApiFilterMultiSelect(props) {
  const {
    label,
    name,
    options,
    placeholder,
    isSelect = false,
    freeSolo = true,
    value,
    id,
    hasSubText = false,
    hasError = false,
    subTextField = { title: "", id: null, subText: [] },
    ...rest
  } = props;

  const getOptionSection = (option) => {
    let optionText = freeSolo ? i18next.t(option) : i18next.t(option.key);

    if (hasSubText && option.key !== "Select All") {
      return (
        <Box className={styles.optionWrapper}>
          <Box className={styles.optionHeader}>
            {_.isNull(id)
              ? option[subTextField.title]
              : `${option[subTextField.id]} : ${option[subTextField.title]}`}
          </Box>
          <Box className={styles.optionSubHeader}>
            {subTextField?.subText.reduce((currentText, field) => {
              let extn = _.isEmpty(currentText) ? "" : ",";
              let textItem = !_.isEmpty(option[field]) ? option[field] : "-";

              return currentText + extn + textItem;
            }, "")}
          </Box>
        </Box>
      );
    } else {
      return optionText;
    }
  };

  return (
    <Box
      className={
        hasError
          ? `${styles.multifiledSelectWrapper} ${styles.inputError}`
          : styles.multifiledSelectWrapper
      }
      data-testid="MultiFieldSelect"
    >
      <Field
        as="select"
        id={name}
        name={name}
        className={`${styles.selectSection}`}
      >
        {({ field, form }) => (
          <FormControl error className={styles.formFieldWrapper}>
            <Autocomplete
              popupIcon={<KeyboardArrowDownOutlinedIcon />}
              multiple
              getOptionLabel={(option) => {
                return freeSolo ? i18next.t(option) : i18next.t(option.key);
              }}
              options={options}
              value={value}
              label={label}
              {...field}
              isOptionEqualToValue={(option, value) =>
                freeSolo ? option === value : option?.value === value?.value
              }
              error={Boolean(form.touched[name] && form.errors[name])}
              disableClearable={isSelect}
              renderOption={(props, option, { selected }) => {
                const selectAllProps =
                  options?.length === value?.length ? { checked: true } : {};
                return (
                  <li
                    {...props}
                    className={
                      hasSubText
                        ? "MuiAutocomplete-option withSubtextOption"
                        : "MuiAutocomplete-option withoutSubtextOption"
                    }
                  >
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      indeterminateIcon={
                        <CheckBoxPartialIcon className={styles.checkedIcon} />
                      }
                      indeterminate={
                        (freeSolo
                          ? option === "Select All"
                          : option.key === "Select All") &&
                        options?.length !== value?.length &&
                        value?.length !== 0
                      }
                      {...selectAllProps}
                    />
                    {getOptionSection(option)}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  hiddenLabel
                  className={`input-grp__box ${
                    isSelect ? "inputSelectStyle" : ""
                  } ${value?.length ? styles.multiSelectInputWithValue : ""}`}
                  type="text"
                  placeholder={placeholder}
                  size="small"
                  variant="filled"
                  {...params}
                />
              )}
              renderTags={(tagValue, getTagProps) => {
                return (
                  <Box className={styles.tagWrapper}>
                    {tagValue.map((label, index) => (
                      <Chip
                        label={
                          freeSolo ? i18next.t(label) : i18next.t(label.key)
                        }
                        {...getTagProps({ index })}
                        className={styles.crossBtn}
                        deleteIcon={<ClearOutlinedIcon />}
                      />
                    ))}
                  </Box>
                );
              }}
              {...rest}
            />
          </FormControl>
        )}
      </Field>
    </Box>
  );
}

export default ApiFilterMultiSelect;

ApiFilterMultiSelect.propTypes = {
  label: PropTypes.any,
  name: PropTypes.any,
  options: PropTypes.any,
  placeholder: PropTypes.any,
  isSelect: PropTypes.any,
  freeSolo: PropTypes.any,
  value: PropTypes.any,
  id: PropTypes.any,
  hasSubText: PropTypes.any,
  hasError: PropTypes.any,
  subTextField: PropTypes.any,
};
